import { useCallback } from 'react';
import { apiHooks } from '../../../hooks/useRestAPIHooks';
import { UseInfiniteQueryResult } from '@tanstack/react-query';
import { TemplatingItemSummary, ModelUtils, Folder } from '../models';

export const AI_TEMPLATES_ROUTE_QUERY_KEY = 'GET /v1/ai-templates';

export type TemplatingItemSummariesQueryResult = NonNullable<
  ReturnType<
    typeof apiHooks.useInfiniteAPIQuery<typeof AI_TEMPLATES_ROUTE_QUERY_KEY>
  >['data']
>;

export const useTemplatingItemSummaries = ({
  prefix,
  pageSize,
  enabled = true,
}: {
  prefix?: string;
  pageSize?: number;
  enabled?: boolean;
} = {}) => {
  const select = useCallback((data: TemplatingItemSummariesQueryResult) => {
    const pages = data.pages.map(page =>
      page.items.map(ModelUtils.templatingItemSummaryFromRawData),
    );
    return {
      pageParams: data.pageParams,
      pages,
    };
  }, []);

  const templatingItemSummariesQuery = apiHooks.useInfiniteAPIQuery(
    AI_TEMPLATES_ROUTE_QUERY_KEY,
    {
      prefix,
      pageSize,
    },
    {
      // @ts-expect-error we can transform the data in the select function, react-client types don't support this
      select,
      getNextPageParam: lastPage => {
        return lastPage.links.next
          ? {
              nextPageToken: lastPage.links.next,
            }
          : undefined;
      },
      enabled,
    },
  );

  return templatingItemSummariesQuery as UseInfiniteQueryResult<
    (TemplatingItemSummary | Folder)[],
    Error
  >;
};
